import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useFirestore, useUser } from 'reactfire';

type UserMeta = {
  role: string;
  email: string;
  uid: string;
};

export const useUserMeta = () => {
  const { data: user } = useUser();
  const firestore = useFirestore();

  const [userMeta, setUserMeta] = useState<UserMeta | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserMeta = async () => {
      if (user?.uid) {
        const userRef = doc(firestore, 'users', user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          setUserMeta(userSnap.data() as UserMeta);
        }
        setLoading(false);
      }
       setLoading(false);
    };

    fetchUserMeta();
  }, [user, firestore]);

  return { userMeta, loading };
};
